<template>
    <div class="container">
        <div>
            <h3>Trip reports</h3>
            <p>User trip reports between periods</p>
        </div>

        <div>

            <feedback :error="tripReport.error" :info="tripReport.info"/>

            <div class="form-group">
                <label>Start Date</label>
                <date-picker bootstrap-styling="true"
                             v-model="tempState.startDate"
                             v-bind:class="{'is-invalid': tripReport.fieldErrors.startDate}"
                             :format="formatDate"
                             :disabled-dates = "tripReport.disableDates"
                            name="startDate" />
                <div class="invalid-feedback" v-if="tripReport.fieldErrors.startDate">
                    {{tripReport.fieldErrors.startDate}}
                </div>
            </div>
            <div class="form-group">
                <label>End Date</label>
                <date-picker bootstrap-styling="true"
                             v-model="tempState.endDate"
                             v-bind:class="{'is-invalid': tripReport.fieldErrors.endDate}"
                             :format="formatDate"
                             :disabled-dates = "tripReport.disableDates"
                             name="endDate" />
                <div class="invalid-feedback" v-if="tripReport.fieldErrors.endDate">
                    {{tripReport.fieldErrors.endDate}}
                </div>
            </div>
            <div class="form-group">
                <button v-on:click="download"
                        type="button"
                        v-if="!tripReport.submitting"
                        class="btn btn-primary">Download</button>
                <button v-on:click="emailReport"
                        type="button"
                        v-if="!tripReport.submitting"
                        class="btn btn-primary ml-2">Email</button>
            </div>
        </div>
    </div>
</template>

<script>
    import DatePicker from "vuejs-datepicker";
    import {formatDate} from '../../utils/formatters';
    import {mapActions, mapState} from "vuex";
    import Feedback from "../commons/feedback";

    export default {
        name: "trip_reports",
        components: {
            DatePicker,
            Feedback
        },
        computed: mapState({
            tripReport: state => state.tripReport,
        }),
        data: function() {
            return {
                tempState: {
                    startDate: undefined,
                    endDate: undefined,
                }
            }
        },
        watch: {
            "tempState.startDate": function(value) {
                //Dont know why datepicker didnt just work...for now this is fine...otherwise if i get a better working date picker will replace this mess
                this.tripsReportChange({name: "startDate", value})
            },
            "tempState.endDate": function(value) {
                //Dont know why datepicker didnt just work...for now this is fine...otherwise if i get a better working date picker will replace this mess
                this.tripsReportChange({name: "endDate", value})
            }
        },
        methods: {
            ...mapActions({
                tripsReportChange: "tripsReportChange",
                validate: "tripReportOnValidate",
                downloadTripReport: "downloadTripReport",
                emailTripReport: "emailTripReport",
            }),
            download: function () {
                console.log(this.tripReport);
                this.validate();
                if(this.tripReport.error){
                    return;
                }
                this.downloadTripReport(function(results) {

                    if(results) {
                        const reader = new FileReader();
                        reader.addEventListener("load", () => {
                            const a = document.createElement("a");
                            document.body.appendChild(a);
                            a.style.display = "none";
                            a.href = reader.result;
                            a.setAttribute("download", "user_trips_report.pdf");
                            a.click();
                        });
                        reader.readAsDataURL(results);
                    }
                });

            },
            emailReport: function () {
                this.validate();
                if(this.tripReport.error){
                    return;
                }
                this.emailTripReport();

            },
            formatDate,
            onChange(event) {
                this.tripsReportChange({name: event.target.name, value: event.target.value})
            },
        },
        mounted() {
            //really dont know why had to do this
            this.tempState.startDate = this.tripReport.startDate;
            this.tempState.endDate = this.tripReport.endDate;

        }
    }
</script>

<style scoped>

</style>
